import { render, staticRenderFns } from "./PanList.vue?vue&type=template&id=a8591d9a&scoped=true&"
import script from "./PanList.vue?vue&type=script&lang=js&"
export * from "./PanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8591d9a",
  null
  
)

export default component.exports